module.exports = __webpack_public_path__ + "static/img/7.ad0b6c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/2/sp/7.png
// module id = 6fp9
// module chunks = 0